import React from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import { ButtonGroup } from '@atlaskit/button';
import { useIssuesCount } from '../../../../../controllers/selected-issue/hooks.tsx';
import type { issuePagination_issueNavigator$key as IssuePaginationKey } from './__generated__/issuePagination_issueNavigator.graphql';
import IssuePaginationNextButton from './next-button/index.tsx';
import IssuePaginationPreviousButton from './previous-button/index.tsx';

export type Props = {
	/**
	 * Relay fragment for issue search data.
	 */
	issueResults: IssuePaginationKey | null;
};

const IssuePagination = ({ issueResults }: Props) => {
	const issuesCount = useIssuesCount();

	const issueResultsData = useFragment<IssuePaginationKey>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment issuePagination_issueNavigator on JiraIssueConnection {
				totalIssueSearchResultCount @required(action: THROW)
				isCappingIssueSearchResult
			}
		`,
		issueResults,
	);

	const isCappingIssueSearchResult = issueResultsData?.isCappingIssueSearchResult ?? false;
	const totalIssueSearchResultCount = issueResultsData?.totalIssueSearchResultCount || issuesCount;

	return (
		<>
			<ButtonGroup>
				<IssuePaginationPreviousButton />
				<IssuePaginationNextButton
					totalResultCount={totalIssueSearchResultCount}
					isCappingIssueSearchResult={isCappingIssueSearchResult}
				/>
			</ButtonGroup>
		</>
	);
};

export default IssuePagination;
